import React from 'react';
import styled from 'styled-components';
import useAboutUsPage from '../utils/useAboutUsPageQuery';
import notNull from '../utils/notNull';
import { Viewport } from '../Settings';

const Container = styled.div`
    display: grid;
    grid-template-columns: repeat(24, minmax(0, 1fr));
    grid-row-gap: var(--size6);

    @media (max-width: ${Viewport.Mobile}px) {
        grid-template-columns: 100%;
        padding: 0 var(--sizeGutters);
    }
`;

const Title = styled.div`
    grid-column: 2 / span 4;
    font-size: var(--size5);
    font-weight: bold;
    line-height: 1.09;
    color: var(--foregroundColor);

    @media (max-width: ${Viewport.Mobile}px) {
        grid-column: 1 / span 1;
    }
`;

const Members = styled.div`
    grid-column: 2 / span 21;
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    grid-column-gap: calc(1 / 24 * 100vw);

    @media not all and (min-width: ${Viewport.TabletLandscape}px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        grid-row-gap: var(--size4);
    }

    @media (max-width: ${Viewport.Mobile}px) {
        grid-column: 1 / span 1;
        grid-template-columns: 100%;
    }
`;

const Member = styled.div`
    //
`;

const Inner = styled.div`
    display: grid;
    grid-template-columns: 100%;
    grid-row-gap: var(--size4);

    @media (max-width: ${Viewport.Mobile}px) {
        grid-row-gap: var(--size2);
    }
`;

const Ratio = styled.div`
    padding-top: calc(4 / 3 * 100%);
    position: relative;
`;

const Img = styled.img`
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const Info = styled.div`
    display: grid;
    grid-template-columns: 100%;
    grid-row-gap: var(--size1);
`;

const Name = styled.div`
    font-size: var(--size2);
    font-weight: bold;
    line-height: 1.57;
    color: var(--foregroundColor);
`;

const Position = styled.div`
    font-size: var(--size2);
    line-height: 1.57;
    color: var(--foregroundColor);
`;

const Link = styled.a`
    font-size: var(--size2);
    line-height: 1.57;
    color: var(--foregroundColor);
    text-decoration: underline;
`;

function printContact(mobile: string): string {
    return mobile.replace(/[\(\)\s]/g, '');
}

function BoardMembers(): React.ReactElement {
    const { boardMembers } = useAboutUsPage();

    return (
        <Container>
            <Title>
                Our board <br />
                members
            </Title>
            <Members>
                {boardMembers &&
                    boardMembers.filter(notNull).map(
                        (member): React.ReactElement => (
                            <Member key={String(member._key)}>
                                <Inner>
                                    {member.image &&
                                        member.image.asset &&
                                        member.image.asset.url && (
                                            <Ratio>
                                                <Img
                                                    src={member.image.asset.url}
                                                />
                                            </Ratio>
                                        )}
                                    <Info>
                                        <Name>{member.name}</Name>
                                        <Position>{member.role}</Position>
                                        {member.phone && (
                                            <Link
                                                href={`tel:${printContact(
                                                    member.phone
                                                )}`}
                                            >
                                                {member.phone}
                                            </Link>
                                        )}
                                        {member.email && (
                                            <Link
                                                href={`mailto:${printContact(
                                                    member.email
                                                )}`}
                                            >
                                                {member.email}
                                            </Link>
                                        )}
                                    </Info>
                                </Inner>
                            </Member>
                        )
                    )}
            </Members>
        </Container>
    );
}

export default React.memo(BoardMembers);
